import React from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { ACTION, ENTITY_TYPE } from '../constants';
import TaskComponent from './TaskComponent';
import { Search } from 'lucide-react';

const ConfigTasks = ({
  isTasksLoading,
  tasksDetails,
  selectedEntityType,
  reviewTask,
  taskId,
}) => {
  if (isTasksLoading && !tasksDetails)
    return (
      <div className='tw-flex tw-flex-col tw-gap-4'>
        <Shimmer height='100px' width='100%' />
        <Shimmer height='300px' width='100%' />
      </div>
    );

  if (selectedEntityType === ENTITY_TYPE.CATEGORY) {
    return (
      <div className='tw-flex tw-flex-col tw-gap-6'>
        <div className='tw-font-medium tw-text-[1.6rem] tw-text-zinc-800'>
          New Categories Configuration
        </div>
        {/* Open Tasks */}
        {tasksDetails?.open_tasks ? (
          <TaskComponent
            tasks={tasksDetails.open_tasks}
            title='Open Tasks'
            action={{
              title: ACTION.REVIEW,
              handler: reviewTask,
              taskId: taskId,
            }}
          />
        ) : null}

        {/* Closed Tasks */}
        {tasksDetails?.closed_tasks ? (
          <TaskComponent
            tasks={tasksDetails.closed_tasks}
            title='Closed Tasks'
            action={{
              title: ACTION.VIEW,
              handler: reviewTask,
              taskId: taskId,
            }}
          />
        ) : null}
      </div>
    );
  }

  return (
    <div className='tw-h-[40rem] tw-flex tw-flex-col tw-gap-3 tw-items-center tw-justify-center'>
      <Search size={30} className='tw-text-zinc-600' />
      <span className='tw-font-medium tw-text-[1.6rem]'>
        Enter the Product ID above, then press Enter to fetch the return
        configuration.
      </span>
    </div>
  );
};

export default ConfigTasks;
